import React from 'react';
import { KEYWORD_TAGS } from '../../lib/smsCompose.js';

/**
 * "Available keywords:" — clickable tags that insert at the message caret.
 * @param {{onInsert: (tag: string) => void}} props
 * @returns {JSX.Element}
 */
export default function KeywordList({ onInsert }) {
  return (
    <div className="text-[11px] leading-5 text-white/70" data-testid="keyword-list">
      <span className="font-semibold text-white/90">Available keywords</span>:{' '}
      {KEYWORD_TAGS.map((t, i) => (
        <React.Fragment key={t}>
          <button
            type="button"
            onClick={() => onInsert(t)}
            className="font-mono text-civix-purpleSoft hover:text-white hover:underline cursor-pointer"
          >
            {t}
          </button>
          {i < KEYWORD_TAGS.length - 1 ? ' , ' : ''}
        </React.Fragment>
      ))}
    </div>
  );
}
